module.exports = __webpack_public_path__ + "media/cg.526299b6.mp4";